import { render, staticRenderFns } from "./EnableEditMode.vue?vue&type=template&id=547afbd8&scoped=true"
import script from "./EnableEditMode.vue?vue&type=script&lang=ts"
export * from "./EnableEditMode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547afbd8",
  null
  
)

export default component.exports